/** @jsxImportSource @emotion/react */

import React, { Component } from 'react';
import { connect } from 'unistore/react';
import { css } from '@emotion/react';
import { toast } from 'react-toastify';

import SidebarAlerts from './sidebar-alerts';
import MarginActions from './actions-required/margin';
import DepositActions from './actions-required/p2p/deposit';
import WithdrawalActions from './actions-required/p2p/withdraw';
import ActionsRequiredControlCenter from './actions-required/control-center';
import UserAlerts from './user-alerts';
import UserAlertsControlCenter from './user-alerts/control-center';
import { bubbleStyle } from './common';

import Draggable from '../../components/DragSidenav';
import BbTabs from '../../components/Tabs';
import IfElse from '../../components/IfElse';
import { Checkbox } from '../../components/FormItems';
import ErrorBoundary from '../../components/ErrorBoundary';

import { checkDocument, requestIdleCb, comeToPapa } from '@utils/customLib';
import {
	actionsCombiner,
	sidebarActions,
	userAlertActions,
	actionsRequiredActions,
} from '@utils/store/actions';

class Notifications extends Component {
	state = {
		nType: 0,
		showSideBarItems: false,
	};

	startX = 0;

	currentX = 0;

	touchingTabSwitch = false;

	$NotifWrapper = React.createRef();

	$MarginActionsExp = React.createRef();

	$DepActionsExp = React.createRef();

	$WithActionsExp = React.createRef();

	$UserAlertsExp = React.createRef();

	showSideBarItemsTimeout = null;

	componentDidUpdate(prevProps) {
		const {
			sideNotificationsOpen,
			__setNotificationRead,
			__fetchSideNotifs,
			__fetchUserAlerts,
			__setUserAlertsRead,
			__fetchActionsRequired,
			sideNotifsCount,
			userAlertsCount,
			actionsRequiredUnreadCount,
			__setActionsRequiredRead,
		} = this.props;
		const { nType } = this.state;

		if (prevProps.sideNotificationsOpen !== sideNotificationsOpen) {
			if (checkDocument()) {
				if (sideNotificationsOpen) {
					clearTimeout(this.showSideBarItemsTimeout);
					this.setState({
						showSideBarItems: true,
					});
					toast.dismiss();
					requestIdleCb(() => {
						__setActionsRequiredRead();
						__fetchSideNotifs();
						__fetchUserAlerts();
						__fetchActionsRequired();
					}, 3000);

					// clearTimeout(this.scrollbarOnTimeout);
					// this.scrollbarOffTimeout = setTimeout(() => {
					// 	if (
					// 		sideNotifsCount === 0 &&
					// 		userAlertsCount + actionsRequiredUnreadCount !==
					// 			0 &&
					// 		nType !== 1
					// 	) {
					// 		requestIdleCb(() => {
					// 			this.toggleNType(1);
					// 		}, 1000);
					// 	}
					// }, 350);
				} else {
					this.showSideBarItemsTimeout = setTimeout(() => {
						this.setState({
							showSideBarItems: false,
						});
					}, 150);
					if (sideNotifsCount !== 0 && nType === 0) {
						requestIdleCb(__setNotificationRead, 5000);
					}
					// clearTimeout(this.scrollbarOffTimeout);
					if (
						userAlertsCount + actionsRequiredUnreadCount !== 0 &&
						nType === 1
					) {
						requestIdleCb(__setUserAlertsRead, 5000);
					}
				}
			}
		}
	}

	componentWillUnmount() {
		this.props.__closeSideNotifs();
	}

	openForYouTab = (_, fn) => {
		this.setState(
			{
				nType: 1,
			},
			() => {
				requestAnimationFrame(() => {
					this.props.__openSideNotifs();
					typeof fn === 'function' && fn();
				});
			}
		);
	};

	openMarginActions = e => {
		this.openForYouTab(e, () => {
			comeToPapa(this.$MarginActionsExp.current, 'b');
		});
	};

	openDepoActions = e => {
		this.openForYouTab(e, () => {
			comeToPapa(this.$DepActionsExp.current, 'b');
		});
	};

	openWithActions = e => {
		this.openForYouTab(e, () => {
			comeToPapa(this.$WithActionsExp.current, 'b');
		});
	};

	openUserAlerts = e => {
		this.openForYouTab(e, () => {
			comeToPapa(this.$UserAlertsExp.current, 'b');
		});
	};

	toggleNType = nType => {
		const {
			__setNotificationRead,
			__setUserAlertsRead,
			sideNotificationsOpen,
		} = this.props;

		this.setState(({ nType: oldnType }) => {
			if (oldnType !== nType && sideNotificationsOpen) {
				requestIdleCb(() => {
					if (oldnType === 0) {
						__setNotificationRead();
					} else {
						__setUserAlertsRead();
					}
				}, 3000);
				return {
					nType,
				};
			}
			return {};
		});
	};

	flushUserAlerts = e => {
		e.preventDefault();
		e.stopPropagation();
		e.nativeEvent.stopImmediatePropagation();
		const { __flushUserAlerts, __submitErrorMsg } = this.props;

		__flushUserAlerts(__submitErrorMsg);
	};

	onTouchStart = e => {
		const { sideNotificationsOpen } = this.props;

		if (sideNotificationsOpen && !this.touchingTabSwitch) {
			this.touchingTabSwitch = true;
			this.startX = e.touches[0].pageX;
			this.currentX = this.startX;
		}
	};

	onTouchMove = e => {
		const { sideNotificationsOpen } = this.props;

		if (sideNotificationsOpen && this.touchingTabSwitch) {
			this.currentX = e.touches[0].pageX;
			if (this.currentX - this.startX > 0) {
				this.touchingTabSwitch = false;
			}
		}
	};

	onTouchEnd = () => {
		const { nType } = this.state;
		const { sideNotificationsOpen } = this.props;

		if (sideNotificationsOpen && this.touchingTabSwitch) {
			this.touchingTabSwitch = false;
			const diff = this.currentX - this.startX;

			if (diff < -90) {
				this.toggleNType(nType === 0 ? 1 : 0);
			}
		}
	};

	render() {
		const {
			__closeSideNotifs,
			sideNotificationsOpen,
			sideNotifsCount,
			userAlertsCount,
			__toggleUserAlerts,
			userAlertsMuted,
			actionsRequiredUnreadCount,
		} = this.props;
		const { nType, showSideBarItems } = this.state;
		return (
			<>
				<Draggable
					pos="right"
					width="400"
					isOpened={sideNotificationsOpen}
					closeSidenav={__closeSideNotifs}
				>
					{showSideBarItems && (
						<div
							ref={this.$NotifWrapper}
							onTouchStart={this.onTouchStart}
							onTouchMove={this.onTouchMove}
							onTouchEnd={this.onTouchEnd}
						>
							<div className="c-window__header--type2">
								ACTION CENTRE:
								<button
									className="c-window__close focus:outline-none focus:shadow-lg"
									tabIndex="0"
									type="button"
									aria-label="close"
									onClick={__closeSideNotifs}
								>
									&times;
								</button>
							</div>
							<div className="bb-notification__notifs">
								<BbTabs
									noSelector
									current={nType}
									// type="hollow"
									className="text-sm bg-snowWhite sticky top-0"
									css={css`
										z-index: 2;
									`}
									titleClass="p-6"
									titleClassCurrent="font-bold"
									chooseCurrent={this.toggleNType}
									fullWidth
									tabTitles={[
										{
											label: 'Updates',
											children: (
												<>
													Updates
													{sideNotifsCount > 0 && (
														<div css={bubbleStyle}>
															{sideNotifsCount}
														</div>
													)}
												</>
											),
										},
										{
											label: 'For You',
											children: (
												<>
													For You
													{userAlertsCount +
														actionsRequiredUnreadCount >
														0 && (
														<div css={bubbleStyle}>
															{userAlertsCount +
																actionsRequiredUnreadCount}
														</div>
													)}
												</>
											),
										},
									]}
								/>

								<IfElse
									condition={nType === 0}
									then={
										<ul className="mt-0 p-0 bb-notifList flex-1">
											<SidebarAlerts />
										</ul>
									}
									else={
										<>
											<div className="border-b border-separatorColor px-4 py-2">
												<Checkbox
													checked={userAlertsMuted}
													onChange={
														__toggleUserAlerts
													}
													name="userAlerts"
													value="mute"
													wrapperClass="px-4 py-3 inline-block"
													btnProps={{
														variant: 'minimal',
														size: 'tiny',
													}}
												>
													MUTE ALERTS
												</Checkbox>
											</div>
											<ErrorBoundary>
												<MarginActions
													innerRef={
														this.$MarginActionsExp
													}
												/>
											</ErrorBoundary>
											<ErrorBoundary>
												<DepositActions
													innerRef={
														this.$DepActionsExp
													}
												/>
											</ErrorBoundary>
											<ErrorBoundary>
												<WithdrawalActions
													innerRef={
														this.$WithActionsExp
													}
												/>
											</ErrorBoundary>

											<UserAlerts
												innerRef={this.$UserAlertsExp}
												flush={this.flushUserAlerts}
											/>
										</>
									}
								/>
							</div>
						</div>
					)}
				</Draggable>
				{!userAlertsMuted && (
					<>
						<UserAlertsControlCenter
							openForYouTab={this.openUserAlerts}
						/>
						<ActionsRequiredControlCenter
							openForYouTab={this.openForYouTab}
							openMarginActions={this.openMarginActions}
							openDepoActions={this.openDepoActions}
							openWithActions={this.openWithActions}
						/>
					</>
				)}
			</>
		);
	}
}

export default connect(
	'sideNotificationsOpen, sideNotifsCount, userAlertsCount, actionsRequiredUnreadCount, userAlertsMuted',
	actionsCombiner(sidebarActions, userAlertActions, actionsRequiredActions)
)(Notifications);
